import { createApi } from 'ngrx-rtk-query';
import { Methods } from 'src/app/shared/types/enums';
import httpClientBaseQuery from '../../../baseQuery';

export const inviteApi = createApi({
  reducerPath: 'inviteApi',
  baseQuery: httpClientBaseQuery,
  tagTypes: ['Invite'],
  endpoints: (build) => ({
    sendInvite: build.mutation<{ data: any }, { data: KeyType }>({
      query: ({ data: body }) => ({
        url: `/invites`,
        body,
        method: Methods.Post
      })
    }),
    sendBulkInvites: build.mutation<{ data: any }, { data: any }>({
      query: ({ data: body }) => ({
        url: `/invites/bulk`,
        body,
        method: Methods.Post
      })
    })
  })
});

export const {
  useSendInviteMutation,
  useSendBulkInvitesMutation,
  usePrefetch: useInvitesPrefetch,
  endpoints: inviteApiEndpoints
} = inviteApi;
